import { render, staticRenderFns } from "./addSearchkeyword.vue?vue&type=template&id=9162094a"
import script from "./addSearchkeyword.vue?vue&type=script&lang=js"
export * from "./addSearchkeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9162094a')) {
      api.createRecord('9162094a', component.options)
    } else {
      api.reload('9162094a', component.options)
    }
    module.hot.accept("./addSearchkeyword.vue?vue&type=template&id=9162094a", function () {
      api.rerender('9162094a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/searchKeyword/addSearchkeyword.vue"
export default component.exports